var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_2479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 19H5.5C4.673 19 4 18.327 4 17.5V2.5C4 1.122 2.879 0 1.5 0H0V1H1.5C2.327 1 3 1.673 3 2.5V17.5C3 18.879 4.121 20 5.5 20H6V21C6 22.654 7.346 24 9 24C10.654 24 12 22.654 12 21V20H16V21C16 22.654 17.346 24 19 24C20.654 24 22 22.654 22 21V20H24V19ZM11 21C11 22.103 10.103 23 9 23C7.897 23 7 22.103 7 21V20H11V21ZM21 21C21 22.103 20.103 23 19 23C17.897 23 17 22.103 17 21V20H21V21ZM23 5.5C23 4.122 21.879 3 20.5 3H8.5C7.121 3 6 4.122 6 5.5V17H23V5.5ZM13 4H16V9H13V4ZM22 16H7V5.5C7 4.673 7.673 4 8.5 4H12V10H17V4H20.5C21.327 4 22 4.673 22 5.5V16Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_2479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.31ded29ce1962e1a6a17062afe9de87b.svg";
export { ForwardRef as ReactComponent };